import { createStyles } from 'antd-style';

export const usePerspectiveStyles = createStyles(({ token, css }) => ({
  modalBody: css`
    max-height: 65vh;
    overflow-y: auto;
    margin: 0 -4px;
  `,

  tenantLabel: css`
    font-weight: 600;
    font-size: 15px;
    color: ${token.colorText};
    padding: 14px 4px 10px;
  `,

  tenantDivider: css`
    height: 1px;
    background: ${token.colorBorderSecondary};
    margin: 2px 0;
  `,

  orgItem: css`
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: ${token.borderRadius}px;
    cursor: pointer;
    transition: background 0.2s;
    margin-bottom: 2px;

    &:hover {
      background: ${token.controlItemBgHover};
    }

    &:active {
      background: ${token.controlItemBgActive};
    }

    &.active {
      background: ${token.controlItemBgActive};
      cursor: default;
    }
  `,

  orgIcon: css`
    font-size: 16px;
    margin-right: 10px;
    color: ${token.colorPrimary};
    flex-shrink: 0;
  `,

  orgName: css`
    flex: 1;
    font-size: 14px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  orgTag: css`
    margin-left: 8px;
    font-size: 11px;
    line-height: 1.3;
    flex-shrink: 0;
  `,

  currentMark: css`
    margin-left: 6px;
    color: #52c41a;
    font-weight: 700;
    flex-shrink: 0;
  `,
}));
